import { render, staticRenderFns } from "./joinTeam.vue?vue&type=template&id=0613e9d1&lang=html&"
import script from "./joinTeam.vue?vue&type=script&lang=ts&"
export * from "./joinTeam.vue?vue&type=script&lang=ts&"
import style0 from "./joinTeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports